/**
 * Use System.JS to load a registered module.
 * The module is set by sdk.setImportMaps (System.addImportMap) and takes the shape:
 * {
 *   imports: {
 *     [moduleName]: moduleUri
 *   }
 * }
 *
 * @param moduleName
 */
export const remoteImport = async <T = {}>(moduleName: string): Promise<T> => {
	// IMPORTANT: Make sure whatever we're loading has an ImportMap defined
	// https://github.com/systemjs/systemjs/blob/main/docs/import-maps.md
	const res = await System.import(moduleName);

	return res as T;
};

export const NO_OP = (): void => {};

export const STABLE_EMPTY_OBJECT = {} as const;
